exports.workEx = [{
    designation:"Web Developer",
    organization:"Global Survey Solutions",
    time:"July 2022 - Present",
    responsibilities : [
      "Developed and maintained responsive web applications using React.js, JavaScript, and CSS.",
      "Integrated RESTful APIs to fetch and display dynamic data efficiently.",
      "Designed and implemented reusable UI components for a consistent user experience.",
      "Optimized website performance and ensured cross-browser compatibility.",
      "Collaborated with backend developers to troubleshoot and enhance API functionality."
    ]
  }]


